import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import BlockUiOverlay from 'components/Expense/BlockUiOverlay';
import BASE_URL from "components/BaseUrl/apiConfig";

const NoteDetails = () => {
    const history = useHistory();
    const { noteId } = useParams();
    const [noteDetails, setNoteDetails] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        // Fetch note details based on noteId
        fetch(`${BASE_URL}/api/StickyNotes/GetStickyNotesbyStickyNotesId?noteId=${noteId}`)
            .then(response => response.json())
            .then(data => {
                console.log(data);
                setNoteDetails(data);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching note details:", error);
                setLoading(false);
            });
    }, [noteId]);

    const goTobuttonClick = () => {
        // Navigate to the notes page
        history.push('/notes');
    };

    const formatUpdatedDate = (dateString) => {
        const date = new Date(dateString);
        const options = {
            timeZone: 'Asia/Kolkata', // Adjust the time zone according to your requirement
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        };
        return date.toLocaleString('en-IN', options);
    };

    return (
        <>
            <Navbar />
            <BlockUiOverlay visible={loading} />
            <div className="cust-div">
                <div className="container mx-auto p-4 h-full">
                    <div className="flex content-center items-center justify-center h-full" >
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg  border-0" style={{ backgroundColor: noteDetails ? noteDetails.color : '#ffffff' }}>
                                {noteDetails ? (
                                    <>
                                        <div className="rounded-t mb-0 px-6 py-6">
                                            <div>
                                                <p className=" text-sm text-xl font-bold">
                                                    {noteDetails.title}
                                                </p>
                                            </div>
                                            <hr className="mt-3 border-b-1 border-blueGray-300" />
                                            {/* Render HTML content safely */}
                                            <div className="note_text_container" style={{ maxHeight: "250px", overflowY: "auto" }}>
                                                <div className="note_text" dangerouslySetInnerHTML={{ __html: noteDetails.text }}></div>
                                            </div>
                                        </div>
                                        <div className="px-6 py-6 flex justify-between items-center">
                                            <p><span className="text-md font-bold">Last Modified Date: {formatUpdatedDate(noteDetails.lastUpdatedDate)}</span></p>
                                            <button
                                                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-2 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                                                type="button"
                                                onClick={goTobuttonClick}
                                            >
                                                Back To Notes
                                            </button>
                                        </div>
                                    </>
                                ) : (
                                    <p>Note not found</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default NoteDetails;
